var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated-spinner",
    id: "loader-1",
    x: "0px",
    y: "0px",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "passive-path",
    d: "M 30,5.0000006 C 16.193631,5.0000006 5.0000007,16.193631 5.0000007,30 5.0000007,43.808042 16.193631,54.999999 30,54.999999 43.806369,54.999999 54.999999,43.808042 54.999999,30 54.998327,16.193631 43.806369,5.0000006 30,5.0000006 Z M 30,49.460056 C 19.252978,49.460056 10.539944,40.748695 10.539944,30 10.539944,19.252978 19.252978,10.539944 30,10.539944 c 10.747022,0 19.458383,8.713034 19.458383,19.460056 0,10.748695 -8.711361,19.460056 -19.458383,19.460056 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-path",
    d: "M 39.721664,13.159374 42.488291,8.3654495 C 38.811722,6.23779 34.55473,5.0000006 30,5.0000006 v 0 5.5399434 0 c 3.544427,0 6.858022,0.963469 9.721664,2.61943 z"
  })));
};
export default SvgLoading;